"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CMYKA = exports.CMYK = exports.RGBA = exports.RGB = exports.GREYA = exports.GREY = exports.BINARY = void 0;
// Shortcuts for common image kinds
const BINARY = 'BINARY';
exports.BINARY = BINARY;
const GREY = 'GREY';
exports.GREY = GREY;
const GREYA = 'GREYA';
exports.GREYA = GREYA;
const RGB = 'RGB';
exports.RGB = RGB;
const RGBA = 'RGBA';
exports.RGBA = RGBA;
const CMYK = 'CMYK';
exports.CMYK = CMYK;
const CMYKA = 'CMYKA';
exports.CMYKA = CMYKA;